<template>
  <div v-if="isRender">
    <div class="loading" v-if="isLoading">
      <div>
        <img src="/interview/static/img/loading.gif">
        <p>Loading...</p>
      </div>
    </div>
    <CamInfo
      :campaignType="campaignType"
      :isInterPlay="isInterPlay"
      :checkDate="checkDate"></CamInfo>
    <router-view></router-view>
  </div>
</template>

<script>
  import _ from 'lodash'
  import { mapState, mapMutations } from 'vuex'
  import { isLogin, checkCampaignType } from '@/assets/func'

  import CamInfo from '@/components/campaign/camMain/CamInfo'

  export default {
    name: 'campaignMain',
    components: {
      CamInfo
    },
    data () {
      return {
        campaign: {},
        isLoading: false,
        isRender: true,
        selectedDate: []
      }
    },
    computed: {
      ...mapState({
        campaignInfo: state => state.campaign.campaignInfo,
        contractData: state => state.campaign.contractData,
        currentCampaign: state => state.campaign.currentCampaign
      }),
      campaignType () { // 상품별 페이지 위한 데이터
        return this.checkCampaignType()
      },
      isInterPlay () {
        if (this.campaign.nm.indexOf('인터플레이') > -1) return true
        if (this.campaign.nm.indexOf('PIP') > -1) return true

        return false
      }
    },
    methods: {
      ...mapMutations([
        'setCampaignDetailTap',
        'setCurrentCampaign',
        'SET_CAMPAIGN_INFO',
        'SET_CONTRACT_DATA',
        'SET_SIZE_DATA',
        'SET_CREATIVE_DATA',
        'SET_GEO_DATA'
      ]),
      checkDate (date) { // 캠페인 상세 -> 상품,사이즈,소재/ 일별 에서 선택여부 확인(상세 데이터 표시/숨김에 사용)
        return this.selectedDate.indexOf(date) > -1
      },
      checkCampaignType () { // 상품별 페이지 -> 일반상품, 인터플레이 구분
        // api나오면 주석 살리고 사용중인 코드 날리고
        return checkCampaignType(
          this.isInterPlay,
          this.currentCampaign.campaign_nm,
          this.contractData.contract
        )
      }
    },
    watch: {
      campaignInfo (val) { // 캠페인 상세 데이터 변경 감지 (ajax -> response 제대로 받아오면 변경)
        // _.isNill -> Null or undefined => return true
        if (!_.isNil(val.campaign_cd)) { // 변경된 캠페인데이터의 코드가 null or undefine인지 확인
          if (_.isNil(this.currentCampaign.campaign_cd)) { // store의 currentCampaign이 존재하는지 확인
            this.setCurrentCampaign(val) // 변경된 정보를 store의 currentCampaign에 저장 -> 캠페인 상세 페이지에서 새로고침 했을때
          }
          this.isLoading = false
        } else {
          this.isLoading = true
        }
      }
    },
    created () {
      if (!isLogin()) { // 로그인여부 확인
        this.$router.push('/')
      } else {
        if (sessionStorage.getItem('iw_c') === null) { // 캠페인 데이터 sessioStore에 유무 확인
          this.isRender = false
          this.$router.push('/campaignList')
          return
        }
        // resultList에서 저장한 캠페인정보 가져옴
        this.campaign = JSON.parse(decodeURIComponent(atob(sessionStorage.getItem('iw_c'))))
        this.isLoading = true
        // 가져온 정보로 캠페인 상세 정보 요청
        this.$store.dispatch('getCampaignDetail', this.campaign.cd)
      }
    },
    beforeDestroy () {
      let obj = {}
      let temp = {
        summary: [],
        detail: []
      }
      this.setCurrentCampaign(obj)
      this.SET_CAMPAIGN_INFO({campaign: obj})
      this.SET_CONTRACT_DATA({campaign: temp})
      this.SET_SIZE_DATA({campaign: temp})
      this.SET_CREATIVE_DATA({campaign: temp})
      this.SET_GEO_DATA({campaign: temp})
      sessionStorage.removeItem('iw_c')
    }
  }
</script>

<style scoped>
  .contentWrapper {
    margin-top: 15px;
  }

  .loading {
    top: 0;
    left: 150px;
    position: fixed;
    width: calc(100% - 150px);
    height: 100%;
    z-index: 999;
  }
  .loading div {
    width: 150px;
    height: 150px;
    margin-left: calc(50% - 100px);
    margin-top: 150px;
    text-align: center;
  }
  .loading div img {
    width: 100%;
    height: 100%;
  }

  @media screen and (max-width: 800px) {
    .loading {
      left: 0;
      width: 100%;
    }
    .loading div {
      width: 80px;
      height: 80px;
      margin-left: calc(50% - 40px);
    }
  }
</style>

<style>
  .top_text {
    font-weight: 500;
    color: #689f38;
    margin-bottom: 5px;
    padding-left: 5px;
    height: 25px;
    line-height: 25px;
  }
  .top_text i {
    vertical-align: middle;
    margin-right: 5px;
  }
  .tableHeader {
    height: 30px;
    white-space: nowrap;
  }
  .tableHeader, .botTableHeader{
    border-bottom: 2px solid #eaeaea;
  }

  /* top table */
  .tableSize {
    width: 100%;
    border-collapse: collapse;
    min-width: 550px;
  }
  .tableSize td {
    border-bottom: 1px solid #eaeaea;
    height: 25px;
    white-space: nowrap;
  }
  .tableSize tr:last-child td {
    border: none;
  }
  .sortCenter {
    text-align: center;
  }
  .sortRight {
    text-align: right;
    padding-right: 15px;
  }
  .data_wrap {
    width: 65px;
    display: block;
    margin-left: calc(50% - 40px);
    text-align: right;
  }
  .topTableWrap {
    width: calc(100% - 20px);
    padding: 5px 10px;
    border-radius: 7px;
    background: #fff;
    border: 1px solid #d1dce3;
    overflow: auto;
  }
  /* bottom table */
  .botTableWrap {
    position: relative;
    display: table;
    width: 100%;
    min-width: 720px;
    margin-top: 50px;
    margin-bottom: 20px;
    justify-content: space-around;
  }
  .botTableSize {
    width: 100%;
    max-width: 900px;
    min-width: 450px;
    border-collapse: collapse;
  }
  .dataTd {
    text-align: center;
    min-width: 40px;
  }
  .bot_dataWrap {
    width: 50px;
    text-align: right;
    margin-left: calc(50% - 30px);
  }

  @media screen and (max-width: 800px) {
    .contentWrapper {
      padding-left: 5px;
      padding-right: 5px;
    }
  }
  @media screen and (max-width: 600px) {
    .topTableWrap {
      width: calc(100% - 22px);
      padding-bottom: 5px;
    }
    .botTableWrap {
      width: 100%;
      display: flex;
      padding: 0;
      padding-top: 30px;
      padding-bottom: 1em;
      min-width: 0;
      margin-top: 30px;
      flex-direction: column;
      align-items: center;
    }
    .botTableWrap.ip {
      padding-top: 5px !important;
      margin-top: 40px !important;
      padding-left: 5px;
      padding-right: 5px;
      width: calc(100% - 10px);
    }
    .botTableSize {
      margin: 5px auto;
      width: 100%;
      min-width: 0;
      border-collapse: collapse;
    }
    .dataTd {
      text-align: right;
      width: 40px;
    }
    .contract_total_text {
      height: 96px !important;
    }
    .contract_total_text.cv_table {
      height: 158px !important;
    }

    .flipTable {
      margin-left: auto;
      margin-right: auto;
      width: calc(100% - 2px);
      min-width: 0;
      white-space: nowrap;
      border-collapse: collapse;
      display: flex;
      justify-content: center;
    }
    .flipTable tr {
      flex-shrink: 0;
      display: inline-block;
    }
    .flipTable tbody {
      -webkit-overflow-scrolling: touch; /* ios 스크롤 부드럽게 */
      display: flex;
      position: relative;
      overflow-x: auto;
    }
    .flipTable tr:first-child td {
      padding-left: 10px;
    }
    .flipTable td {
      display: block;
      line-height: 30px;
      /* text-align: right; */
      border: none;
      height: 30px;
      padding-right: 10% !important;
    }
    .flipTable th {
      display: block;
      border: none;
      line-height: 30px;
      text-align: left;
      padding-right: 5px;
      padding-left: 5px;
      border-right: 2px solid #d1dce3;
      height: 30px;
    }
    .flipTable tr:last-child th, .flipTable tr:last-child td {
      border-right: none;
    }
    .sortCenter {
      text-align: center !important;
    }
  }
</style>



// WEBPACK FOOTER //
// CampaignMain.vue?f79e487a